"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsLegalEventType = void 0;
var ProductsLegalEventType;
(function (ProductsLegalEventType) {
    ProductsLegalEventType["WelcomeViewedEvent"] = "welcome_screen_viewed";
    ProductsLegalEventType["SignInViewedEvent"] = "sign_in_screen_viewed";
    ProductsLegalEventType["SignInRequestEvent"] = "login";
    ProductsLegalEventType["SignUpViewedEvent"] = "sign_up_screen_viewed";
    ProductsLegalEventType["ForgotEmailViewedEvent"] = "forgot_email_screen_viewed";
    ProductsLegalEventType["CustomerServiceCallEvent"] = "customer_service_call_initiated";
    ProductsLegalEventType["CustomerServiceEmailEvent"] = "customer_service_email_initiated";
    ProductsLegalEventType["CustomerServiceChatEvent"] = "customer_service_live_chat_initiated";
    ProductsLegalEventType["ForgotPasswordViewedEvent"] = "forgot_password_screen_viewed";
    ProductsLegalEventType["ForgotPasswordRequestEvent"] = "forgot_password_initiated";
    ProductsLegalEventType["HomeViewedEvent"] = "home_screen_viewed";
    ProductsLegalEventType["RequestConsultEvent"] = "request_consult_initiated";
    ProductsLegalEventType["EmergencyCallEvent"] = "emergency_call_initiated";
    ProductsLegalEventType["ManageAccountViewedEvent"] = "manage_account_link_viewed";
    ProductsLegalEventType["HowToCancelViewedEvent"] = "how_to_cancel_viewed";
    ProductsLegalEventType["DeleteAccountEvent"] = "delete_account";
    ProductsLegalEventType["TermsOfServiceViewedEvent"] = "terms_of_service_link_viewed";
    ProductsLegalEventType["PrivacyPolicyViewedEvent"] = "privacy_policy_link_viewed";
    ProductsLegalEventType["MemberPerksViewedEvent"] = "member_perks_link_viewed";
    ProductsLegalEventType["FormsViewedEvent"] = "forms_link_viewed";
    ProductsLegalEventType["SignOutEvent"] = "sign_out_complete";
    ProductsLegalEventType["CheckoutViewedEvent"] = "checkout_viewed";
    ProductsLegalEventType["HelpMeChooseViewedEvent"] = "help_me_choose_viewed";
    ProductsLegalEventType["EmergencyLegalAccessViewedEvent"] = "emergency_legal_access_viewed";
    ProductsLegalEventType["PendingInvitationAlertViewed"] = "pending_invitation_alert_viewed";
    ProductsLegalEventType["PendingInvitationAlertDismissed"] = "pending_invitation_alert_dismissed";
    ProductsLegalEventType["PendingInvitationEmailResent"] = "pending_invitation_email_resent";
    ProductsLegalEventType["PushNotificationEnabledEvent"] = "push_notification_enabled";
    ProductsLegalEventType["PushNotificationViewedEvent"] = "push_notification_viewed";
    ProductsLegalEventType["PushNotificationDeclinedEvent"] = "push_notification_declined";
    ProductsLegalEventType["SignInErrorEvent"] = "sign_in_error";
    ProductsLegalEventType["SignUpErrorEvent"] = "sign_up_error";
    ProductsLegalEventType["UserFetchErrorEvent"] = "fetch_user_error";
    ProductsLegalEventType["EntitlementFetchErrorEvent"] = "fetch_entitlement_error";
    ProductsLegalEventType["EligibilitiesFetchErrorEvent"] = "fetch_eligibilities_error";
    ProductsLegalEventType["FreemiumEligibilitiesFetchErrorEvent"] = "fetch_freemium_eligibilities_error";
    ProductsLegalEventType["AuthorizedUsersFetchErrorEvent"] = "fetch_authorized_users_error";
    ProductsLegalEventType["AuthorizedUsersRemoveErrorEvent"] = "remove_authorized_users_error";
    ProductsLegalEventType["PartnerBranchesFetchErrorEvent"] = "fetch_partner_branches_error";
    ProductsLegalEventType["PartnerBranchFetchErrorEvent"] = "fetch_partner_branch_error";
    ProductsLegalEventType["InvitationsFetchErrorEvent"] = "fetch_invitations_error";
    ProductsLegalEventType["InvitationsCreateErrorEvent"] = "create_invitations_error";
    ProductsLegalEventType["InvitationsResendErrorEvent"] = "resend_invitations_error";
    ProductsLegalEventType["InvitationsUpdateErrorEvent"] = "update_invitations_error";
    ProductsLegalEventType["ForgotPasswordErrorEvent"] = "forgot_password_error";
    ProductsLegalEventType["UpdatePasswordErrorEvent"] = "update_password_error";
    ProductsLegalEventType["QuestionnaireFetchErrorEvent"] = "fetch_questionnaire_error";
    ProductsLegalEventType["AnswerFetchErrorEvent"] = "fetch_answer_error";
    ProductsLegalEventType["AnswerUpdateErrorEvent"] = "update_answer_error";
    ProductsLegalEventType["AnswerSubmitErrorEvent"] = "submit_answer_error";
    ProductsLegalEventType["AttachmentUploadErrorEvent"] = "upload_attachment_error";
    ProductsLegalEventType["AnswerS3FetchErrorEvent"] = "fetch_answer_s3_download_error";
    ProductsLegalEventType["ContractFetchErrorEvent"] = "fetch_contract_error";
    ProductsLegalEventType["ServiceRequestsFetchErrorEvent"] = "fetch_service_requests_error";
    ProductsLegalEventType["AlertsFetchErrorEvent"] = "fetch_alerts_error";
    ProductsLegalEventType["AlertsAcknowledgeAlertErrorEvent"] = "acknowledge_alert_error";
    ProductsLegalEventType["UserStatesFetchErrorEvent"] = "fetch_user_states_error";
    ProductsLegalEventType["UserStatesCreateErrorEvent"] = "create_user_states_error";
    ProductsLegalEventType["IdentityFetchErrorEvent"] = "fetch_identity_error";
    ProductsLegalEventType["IdentityDeleteErrorEvent"] = "delete_identity_error";
    ProductsLegalEventType["BiometricsEnabledEvent"] = "biometrics_enabled";
    ProductsLegalEventType["BiometricsDisabledEvent"] = "biometrics_disabled";
    ProductsLegalEventType["RequestConsultInitiated"] = "request_consult_initiated";
    ProductsLegalEventType["RequestConsultExited"] = "request_consult_exited";
    ProductsLegalEventType["RequestConsultSubmitted"] = "request_consult_submitted";
    ProductsLegalEventType["ProductBenefitsViewed"] = "product_benefits_viewed";
    ProductsLegalEventType["BenefitDetailsViewed"] = "benefit_details_viewed";
    ProductsLegalEventType["AttachmentUploaded"] = "attachment_uploaded";
})(ProductsLegalEventType = exports.ProductsLegalEventType || (exports.ProductsLegalEventType = {}));
//# sourceMappingURL=analytics-products-legal-event-type.js.map